module.exports = __webpack_public_path__ + "img/user-1.76d33acb.jpg";